export function OutlineRouteIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50311 9.14258C3.44335 9.14258 1.6918 13.879 4.08639 16.5711L5.31967 17.8092L7.50311 20.0022L9.69615 17.8092L10.8335 16.6718C13.3384 13.9941 11.6013 9.14738 7.49831 9.14738L7.50311 9.14258Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M18.2522 3.0048C15.776 3.0048 14.7059 5.89366 16.1647 7.53964L16.9181 8.29304L18.2522 9.6319L19.591 8.29304L20.2869 7.59722C21.8177 5.96084 20.7571 3 18.2522 3V3.0048Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M11.9995 21.0006H19.0009C20.1046 21.0006 20.9972 20.108 20.9972 19.0043C20.9972 17.8958 20.1046 17.0032 19.0009 17.0032H16.995C15.8913 17.0032 14.9987 16.1107 14.9987 15.0069C14.9987 13.8984 15.8913 13.0059 16.995 13.0059H17.998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
